import { render, staticRenderFns } from "./EditRemarkDialog.vue?vue&type=template&id=d01e138e&scoped=true"
import script from "./EditRemarkDialog.vue?vue&type=script&lang=js"
export * from "./EditRemarkDialog.vue?vue&type=script&lang=js"
import style0 from "./EditRemarkDialog.vue?vue&type=style&index=0&id=d01e138e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01e138e",
  null
  
)

export default component.exports